// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"31d6cfe0","628":"58444d3f","781":"49180ff1","805":"31d6cfe0","955":"d48dc8e4"}[chunkId] + ".chunk.css";
};